import { type UseMutationResult, useMutation } from '@tanstack/react-query';

import api from '@/api/axios';

export const useGetAuditCaseDocumentDownloadUrl = (): UseMutationResult<
  { url: string },
  Error,
  { auditCaseUuid: string; documentUuid: string }
> => {
  return useMutation({
    mutationFn: async ({ auditCaseUuid, documentUuid }) => {
      const { data } = await api.get<{ url: string }>(
        `/audit-cases/${auditCaseUuid}/documents/${documentUuid}`,
      );

      return data;
    },
  });
};
